module.exports = __webpack_public_path__ + "img/FutebolDeRua2.198bd84a.jpg";